module.exports = __webpack_public_path__ + "static/img/personIcon.febc996.svg";